site.headSearch = {
	init: function() {
		$('#searchToggle').on('click', function () {
			if ($('body').hasClass('search-open')) {
				site.headSearch.closeSearch();
			} else {
				$('body').addClass('search-open');
				$('.searchDrop').find('#q').focus();
			}
		});

		$('#searchClose').on('click', function () {
			site.headSearch.closeSearch();
		});

		// Add search to mobile menu
		var $searchForm = $('#searchForm');
		var $menu = $('ul.mmLevel1', '#mobilemenu');
		$menu.prepend($searchForm.clone().wrap("<li class='search'></div>").parent());
		$('#q', '#mobilemenu').attr('id', 'mobileQ');
		$('#elm_q > label', '#mobilemenu').attr('for', 'mobileQ');

		// Close search on esc press
		$(document).keydown(function(e) {
			if (e.keyCode === 27) {
				site.headSearch.closeSearch();
			}
		});

		var $body = $('body');
		$(document).on('click touchstart', function(e) {
			if ($body.is('.search-open')) {
				var container = $(".searchDrop, #searchToggle, #searchClose");
				if (!container.is(e.target) && container.has(e.target).length === 0) {
					site.headSearch.closeSearch();
				}
			}
		});

		site.headSearch.setSearchClosePosition();

		window.addEventListener('resize', function(){
			site.headSearch.setSearchClosePosition();
		});

	},

	closeSearch: function() {
		$('body').removeClass('search-open');
	},

	setSearchClosePosition: function() {
		const searchToggle = document.getElementById('searchToggle'),
			searchClose = document.getElementById('searchClose'),
			divisionPicker = document.getElementById('divisionToggle');

		if (divisionPicker) {
			searchClose.style.right = window.innerWidth - searchToggle.getBoundingClientRect().right + 'px';
		}
	}
};

site.inits.push('site.headSearch.init()');
